export const replaceWithAsterisks = (str: string, index: number, n: number) => {
  const before = str.slice(0, index);
  const after = str.slice(index + n);
  const asterisks = '*'.repeat(n);
  return before + asterisks + after;
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
